// extracted by mini-css-extract-plugin
export var aligned = "RichTextImage-module--aligned--709df";
export var caption = "RichTextImage-module--caption--ffecc";
export var center = "RichTextImage-module--center--64fbf";
export var innerContainer = "RichTextImage-module--innerContainer--4373f";
export var left = "RichTextImage-module--left--f3ee7";
export var modalCloseButton = "RichTextImage-module--modalCloseButton--34000";
export var outerContainer = "RichTextImage-module--outerContainer--3c3e4";
export var overlay = "RichTextImage-module--overlay--9b7fa";
export var right = "RichTextImage-module--right--10ed3";